
import React from 'react';
import CheckStepWidget from './CheckStepWidget.jsx';


export default () => (
    <div className="trit-container trit-container-print">
        <header>
            <img src="images/logo.png" alt="logo" />
            <h1>Приём заявления в электронном виде</h1>
            <br />
        </header>

        <div className="col-md-12">
            <CheckStepWidget  />
        </div>
    </div>
);
